const nbgSyncCurrentChoices = () => {
  document.querySelectorAll('.nbg-chip').forEach((link) => {
    if (link.classList.contains('is-current')) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
};
document.addEventListener('collection:reloaded', () => {
  const current = new URL(window.location.href);
  const min = current.searchParams.get('filter.v.price.gte');
  const max = current.searchParams.get('filter.v.price.lte');
  document.querySelectorAll('.nbg-weight-row a, .nbg-choice-group--origin a, .nbg-choice-group--type a').forEach((link) => {
    const target = new URL(link.href);
    for (const [key, value] of [['filter.v.price.gte', min], ['filter.v.price.lte', max]]) {
      target.searchParams.delete(key);
      if (value) target.searchParams.set(key, value);
    }
    link.href = target.pathname + target.search;
  });
  document.querySelectorAll('.nbg-choice-group--budget a').forEach((link) => {
    const target = new URL(link.href);
    link.classList.toggle('is-current', Number(target.searchParams.get('filter.v.price.gte')) === Number(min) && Number(target.searchParams.get('filter.v.price.lte')) === Number(max));
  });
  nbgSyncCurrentChoices();
});
nbgSyncCurrentChoices();
